import React from 'react'
import { Link } from 'react-router-dom';
import styled from 'styled-components';

const ImgBack = styled.img`
    position: absolute;
    width: 8.75px;
    height: 16px;
    left: 24px;
    top: 24px;
`;

const DivText1 = styled.div`
    position: absolute;
    right: 16px;
    height: 56px;
    left: 16px;
    top: 92px;

    /* 2 */

    font-family: 'Pretendard';
    font-style: normal;
    font-weight: 700;
    font-size: 24px;
    line-height: 28px;
    /* or 117% */

    letter-spacing: -0.02em;

    /* Default/Gray/700 */

    color: #333333;
`;

const DivText2 = styled.div`
    box-sizing: border-box;

    /* Auto layout */

    display: flex;
    flex-direction: row;
    align-items: flex-start;
    padding: 16px;
    gap: 10px;

    position: absolute;
    right: 16px;
    height: 52px;
    left: 16px;
    top: 180px;

    /* White */

    background: #FFFFFF;
    /* Default/Gray/200 */

    border: 1.5px solid #E2E2E2;
    border-radius: 12px;
`;

const BtnNext = styled.button`
    position: absolute;
    right: 16px;
    height: 48px;
    left: 16px;
    top: 256px;

    background: #55A5DB;
    border-radius: 24px;
    color: #fff;
    border: none;
`;

function JoinPage2(props) {
    return (
        <div >
            <ImgBack src="/images/arrow-back.png" alt="back" onClick={() => props.history.goBack()} />

            <DivText1>닉네임을<br />설정해주세요</DivText1>
            <DivText2>닉네임</DivText2>

            <Link to='join3'>
                <BtnNext>
                    다음
                </BtnNext>
            </Link>
        </div>
    )
}

export default JoinPage2